import cmsfLogo from '../../../components/Header/cmsf.jpg'
const SettlementWorkflowForwardMail = () => {
  
  return (
    <div style={{ backgroundColor: '#dbddde', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif' }}>
      {/* Preload images - in React we'd typically handle this differently */}
      <div >
        {[
          'https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-header.png',
          cmsfLogo,
          'https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-chat.png',
          'https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-icon.png',
          'https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-academy.png',
          'https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-footer.png'
        ].map((src, index) => (
          <link key={index} rel="preload" as="image" href={src} />
        ))}
      </div>

      {/* Hidden preview text */}
      <div style={{ display: 'none', overflow: 'hidden', lineHeight: '1px', opacity: 0, maxHeight: 0, maxWidth: 0 }}>
        Google Play developers
        {/* <div>
          {Array(150).fill('\u200C\u200B\u200D\u200E\u200F\u00A0').join('')}
        </div> */}
      </div>

      {/* Main email container */}
      <div style={{ maxWidth: '37.5em', margin: '30px auto', backgroundColor: '#fff', borderRadius: '5px', overflow: 'hidden' }}>
        
        {/* Header section */}
        <div>
          <img
            alt="Google Play developers header blue transparent"
            height="100%"
            src="https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-header.png"
            style={{ display: 'block', outline: 'none', border: 'none', textDecoration: 'none', marginTop: '-1px' }}
            width="100%"
          />
          <img
            alt="Google Play"
            height="31"
            src="https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-logo.png"
            style={{ display: 'block', outline: 'none', border: 'none', textDecoration: 'none', padding: '0 40px' }}
            width="155"
          />
        </div>

        {/* Content section */}
        <div style={{ padding: '0 40px' }}>
          <hr style={{ width: '100%', border: 'none', borderTop: '1px solid #e8eaed', margin: '20px 0' }} />
          
          <p style={{ fontSize: '14px', lineHeight: '26px', fontWeight: 700, color: '#004dcf', margin: '16px 0' }}>
            DEVELOPER UPDATE
          </p>
          
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            Hello Google Play Developer,
          </p>
          
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            We strive to make Google Play a safe and trusted experience for users.
          </p>
          
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            We've added clarifications to our{' '}
            <a
              href="https://notifications.google.com"
              style={{ color: '#004dcf', textDecoration: 'none', fontSize: '14px', lineHeight: '22px' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Target API Level policy
            </a>. Because this is a clarification, our enforcement standards and practices for this policy remain the same.
          </p>
        </div>

        {/* Policy exceptions section */}
        <div style={{ paddingLeft: '40px' }}>
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            We're noting exceptions to the{' '}
            <a
              href="https://notifications.google.com"
              style={{ color: '#004dcf', textDecoration: 'none', fontSize: '14px', lineHeight: '22px' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Target API Level policy
            </a>, which can be found in our updated{' '}
            <a
              href="https://notifications.google.com"
              style={{ color: '#004dcf', textDecoration: 'none', fontSize: '14px', lineHeight: '22px' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Help Center article.
            </a> These exceptions include permanently private apps and apps that target automotive or wearables form factors and are bundled within the same package.{' '}
            <a
              href="https://notifications.google.com"
              style={{ color: '#004dcf', textDecoration: 'none', fontSize: '14px', lineHeight: '22px' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </a>
          </p>
        </div>

        {/* Deadline extension section */}
        <div style={{ padding: '0 40px' }}>
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            We're also extending the deadline to give you more time to adjust to these changes. Now, apps that target API level 29 or below will start experiencing reduced distribution starting <b>Jan 31, 2023</b> instead of Nov 1, 2022. If you need more time to update your app, you can request an extension to keep your app discoverable to all users until May 1, 2023.
          </p>
          
          <hr style={{ width: '100%', border: 'none', borderTop: '1px solid #e8eaed', margin: '20px 0' }} />
        </div>

        {/* Closing section */}
        <div style={{ padding: '0 40px' }}>
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            Thank you,
          </p>
          
          <p style={{ fontSize: '20px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            ICT Department, CMSF
          </p>
        </div>

        {/* Connect section */}
        <div style={{ backgroundColor: '#f0fcff', width: '90%', borderRadius: '5px', overflow: 'hidden', paddingLeft: '20px', margin: '0 auto' }}>
          <p style={{ fontSize: '14px', lineHeight: '22px', color: '#3c4043', margin: '16px 0' }}>
            Connect with us
          </p>
          
          <div style={{ display: 'flex', gap: '4px', marginBottom: '16px' }}>
            {[
              { src: 'google-play-chat.png', alt: 'Chat', href: 'https://notifications.google.com' },
              { src: 'google-play-icon.png', alt: 'Icon', href: 'https://notifications.google.com' },
              { src: 'google-play-academy.png', alt: 'Academy', href: 'https://notifications.google.com' }
            ].map((item, index) => (
              <a
                key={index}
                href={item.href}
                style={{ color: '#067df7', textDecoration: 'none' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="28"
                  src={`https://react-email-demo-c5c0ph259-resend.vercel.app/static/${item.src}`}
                  style={{ display: 'block', outline: 'none', border: 'none', textDecoration: 'none' }}
                  width="28"
                  alt={item.alt}
                />
              </a>
            ))}
          </div>
          
          <img
            height="100%"
            src="https://react-email-demo-c5c0ph259-resend.vercel.app/static/google-play-footer.png"
            style={{ display: 'block', outline: 'none', border: 'none', textDecoration: 'none', maxWidth: '100%' }}
            width="100%"
            alt="Google Play Footer"
          />
        </div>

        {/* Footer section */}
        <div style={{ padding: '0 40px 30px' }}>
          <p style={{ fontSize: '12px', lineHeight: '22px', color: '#3c4043', textAlign: 'center', margin: 0 }}>
            © { new Date().getFullYear()  } CMSF 3rd Floor, DCCI Building, 65-66 Motijheel C/A Dhaka-1000
          </p>
          
          <p style={{ fontSize: '12px', lineHeight: '22px', color: '#3c4043', textAlign: 'center', margin: 0 }}>
            You have received this mandatory email service announcement to update you about important changes to your INSAF Settlement Workflow.
          </p>
        </div>
      </div>
    </div>
  )
}

export default SettlementWorkflowForwardMail